<template lang="html">
    <div class="content-wy">
        <div class="page-header">
            <h1>{{datainfo.name}}听力列表 <span v-html="qrcode"></span> </h1>
            <h2>{{URLcs.name}}</h2>
        </div>
        <table class="table table-hover">
            <tr v-for="datainfo in datainfo">
                <td>{{datainfo.name}}</td>
                <td style="width: 45px;cursor: pointer;" @click="findthistl(datainfo.url)" data-toggle="modal" data-target=".shiting">试听</td>
                <template v-if="wyrole == 'YES'">
                    <td style="width: 80px;cursor: pointer;"><a href="{{datainfo.url}}" download="download" target="_blank">【下载】</a></td>
                </template>
                <template v-else>
                    <td style="width: 80px;cursor: pointer;" @click="download($index)"><a>【下载】</a></td>
                </template>
            </tr>
        </table>
        <page :turn-page="pageData"></page>
    </div>

    <!-- Modal -->
    <div class="modal fade shiting" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-bg">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">Close</span></button>
                    <h4 class="modal-title" id="myModalLabel">试听</h4>
                </div>
                <div class="modal-body">
                    <!--<img :src="thistldata.logo"  />-->
                    <!--<p style="text-align: center;">
                        <audio src="{{url}}" controls="controls"></audio>
                    </p>-->
                    <div style="text-align: center;">  	<player  :src="url"></player> </div>
                    
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-default btn-sm" data-dismiss="modal">关闭</button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import qrCode from 'qrcode-npm'
    import M from '../assets/common.js'
    import C from '../assets/config.js'
    import page from '../components/page.vue'
    import player from '../components/listenPlayer.vue'
    export default {
        data: () => ({
            host: C.host,
            URLcs: M.getUrlParams(),
            pageData: {},
            datainfo: {},
            url: '',
            wyrole: localStorage.getItem('wyrole'),
            qrcode: ''
        }),
        events: {
            'child-turn-page' (obj) {
                this.pageNo = obj.pageNo;
                this.finddata();
            },
        },
        components: {
            page,
            player
        },
        created: function () {
          this.finddata();
        },
        ready: function () {
          this.getQrcode();
        },
        methods: {
            findthistl: function (url) {
                this.$set('url', url);
            },
            tishi: function () {
                M.topRightInfoTips({
                    title: '没有下载权限！'
                })
            },
            download:function(index){
                if(localStorage.getItem('wyrole')){
            

                }else{
                    this.tishi();
                }
            },
            getQrcode: function () {
                let qr = qrCode.qrcode(4, 'M');
//                let name = encodeURIComponent(this.URLcs.name);
                qr.addData("http://www.scwywh.com/mobile.html#/listenOneBook?id=" + this.URLcs.id);
                qr.make();
                let code = qr.createImgTag(4);
                this.$set('qrcode', code);
            },
            //查询听力
            finddata() {
                let url = this.host + 'wuyan/user/listenUnit';
                let self = this;
                let postParam = {};
                postParam.listenId = this.URLcs.id;
                postParam.pageNo = this.pageNo;
                postParam.pageSize = 15;
                M.load(url, postParam, function (data) {
                    if (data.hasOwnProperty('code')) {
                        M.topRightInfoTips({
                            title: '还没有相关听力！！'
                        })
                    } else {
                        self.$set('datainfo', data.data.list)
                        self.$set('pageData', data.data)
                    }
                }, 'get');
            },
        }
    }

</script>
<style scoped>
    .content-wy {
        margin: 20px auto;
        width: 1200px;
        border: 2px solid #dddddd;
        padding: 0px 0;
        box-shadow: 1px 1px 1px 1px #dddddd;
        border-radius: 3px;
    }
</style>



// WEBPACK FOOTER //
// listenbookpc.vue?911de1ae